module.exports = __webpack_public_path__ + "img/elipse_big.06d7d715.svg";